import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33a80760"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "physical-data" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "physical-data__title" }, " Физические данные ", -1 /* HOISTED */))

import DigitalBlock from "@/searchSection/components/SearchPanel/DigitalBlock.vue";
import { useSearchStore } from "@/searchSection/store/searchStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchByPhysicalData',
  setup(__props) {

const searchStore = useSearchStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(DigitalBlock, {
      first: _unref(searchStore).searchOptions.age.from,
      "onUpdate:first": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchStore).searchOptions.age.from) = $event)),
      second: _unref(searchStore).searchOptions.age.to,
      "onUpdate:second": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchStore).searchOptions.age.to) = $event)),
      title: 'Возраст',
      orText: "-",
      firstPlaceholder: 'От 18 лет',
      secondPlaceholder: 'До 35 лет'
    }, null, 8 /* PROPS */, ["first", "second"]),
    _createVNode(DigitalBlock, {
      first: _unref(searchStore).searchOptions.bustSize.from,
      "onUpdate:first": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchStore).searchOptions.bustSize.from) = $event)),
      second: _unref(searchStore).searchOptions.bustSize.to,
      "onUpdate:second": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchStore).searchOptions.bustSize.to) = $event)),
      title: 'Размер груди',
      orText: "-",
      firstPlaceholder: 'От 1',
      secondPlaceholder: 'До 12'
    }, null, 8 /* PROPS */, ["first", "second"]),
    _createVNode(DigitalBlock, {
      first: _unref(searchStore).searchOptions.height.from,
      "onUpdate:first": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchStore).searchOptions.height.from) = $event)),
      second: _unref(searchStore).searchOptions.height.to,
      "onUpdate:second": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchStore).searchOptions.height.to) = $event)),
      title: 'Рост',
      orText: "-",
      firstPlaceholder: 'От 150 см',
      secondPlaceholder: 'До 210 см'
    }, null, 8 /* PROPS */, ["first", "second"]),
    _createVNode(DigitalBlock, {
      first: _unref(searchStore).searchOptions.weight.from,
      "onUpdate:first": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchStore).searchOptions.weight.from) = $event)),
      second: _unref(searchStore).searchOptions.weight.to,
      "onUpdate:second": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchStore).searchOptions.weight.to) = $event)),
      title: 'Вес',
      orText: "-",
      firstPlaceholder: 'От 20 кг',
      secondPlaceholder: 'До 190 кг'
    }, null, 8 /* PROPS */, ["first", "second"])
  ]))
}
}

})